import { ToastAlertTypes } from '@genial/components';

export const screenName = 'batch-ticket-redeem';
export const successRequestRedeemSpreadsheetMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Solicitação realizada com sucesso!',
  'A planilha base para resgate foi solicitada. Clique em ATUALIZAR para verificar quando estiver disponível para download.',
];
export const errorRequestRedeemSpreadsheetMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao solicitar planilha base para resgate,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];
export const errorDownloadRedeemSpreadsheetMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao baixar esta planilha,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];
export const errorImportRedeemSpreadsheetMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao importar planilha,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];
